import styles from "./VLModalTitle.module.scss";

export type VLModalTitleProps = {
  title: string;
  subtitle: string;
};

export const VLModalTitle = ({ title, subtitle }: VLModalTitleProps) => (
  <div className={styles.root}>
    <span>{title}</span>
    <span className={styles.subtitle}>{subtitle}</span>
  </div>
);
